import { computed, defineComponent, onBeforeUnmount, onMounted, ref, useContext, useCssModule, } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'BoxEmbed',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const context = useContext();
        const viewport = context.$viewport;
        const defaultHeight = computed(() => (viewport.isLessThan('tablet') ? 150 : 300));
        const height = ref(props.box.data?.height || defaultHeight.value);
        const iframeEl = ref();
        const iframeId = ref(props.box.data?.service || '');
        const iframeSrc = computed(() => {
            let { embed = '' } = props.box.data || {};
            const { service = '' } = props.box.data || {};
            if (service === 'twitter') {
                // https://twitframe.com
                embed += '&conversation=none&align=center';
            }
            return embed;
        });
        const intersectionObserver = ref();
        const isLoaded = ref(false);
        const rootEl = ref();
        const shouldLoadIframe = ref(false);
        function handleIframeError() {
            console.error(`An error occurred while loading the #${iframeId.value}. Additional info:`, props.box.data);
            isLoaded.value = true;
        }
        function handleIframeLoad() {
            if (!iframeEl.value) {
                return;
            }
            const { service = '' } = props.box.data || {};
            switch (service) {
                case 'twitter':
                    // https://twitframe.com/#sizing
                    iframeEl.value?.contentWindow?.postMessage({ element: iframeId.value, query: 'height' }, 'https://twitframe.com');
                    break;
                case 'youtube':
                    isLoaded.value = true;
                    break;
            }
        }
        function listenMessage({ data, origin }) {
            if (!data) {
                return;
            }
            const { service = '' } = props.box.data || {};
            switch (true) {
                case service === 'infogram' && origin.includes('infogram'):
                    if (typeof data === 'object') {
                        const shift = viewport.isLessThan('tablet') ? 32 : 56;
                        height.value = data?.height + shift || defaultHeight.value;
                    }
                    if (!isLoaded.value) {
                        isLoaded.value = data === 'frameRender';
                    }
                    break;
                case service === 'instagram' && origin.includes('instagram'):
                    if (typeof data === 'string') {
                        const obj = JSON.parse(data);
                        height.value = obj?.details?.height || defaultHeight.value;
                        if (!isLoaded.value) {
                            isLoaded.value = obj?.type === 'MOUNTED';
                        }
                    }
                    break;
                case service === 'twitter' && origin.includes('twitframe'):
                    height.value = data?.height || defaultHeight.value;
                    if (!isLoaded.value) {
                        isLoaded.value = true;
                    }
                    break;
            }
        }
        onBeforeUnmount(() => {
            window.removeEventListener('message', listenMessage);
        });
        onMounted(() => {
            if (!rootEl.value) {
                return;
            }
            iframeId.value += `_${(Math.random() * 100000000).toFixed(0)}`;
            intersectionObserver.value = new IntersectionObserver(([entry]) => {
                if (entry?.intersectionRatio > 0) {
                    shouldLoadIframe.value = true;
                    window.addEventListener('message', listenMessage);
                }
            });
            intersectionObserver.value?.observe(rootEl.value);
        });
        return {
            css,
            defaultHeight,
            iframeId,
            handleIframeError,
            handleIframeLoad,
            height,
            iframeEl,
            iframeSrc,
            intersectionObserver,
            isLoaded,
            rootEl,
            shouldLoadIframe,
        };
    },
});
